import { API } from '@/config';
import type { UpdateSettingsRequest, UserSettings } from '@/types';
import { api } from './client';

/** The signed-in user's own Settings. */
export const settingsService = {
  get(signal?: AbortSignal): Promise<UserSettings> {
    return api.get<UserSettings>(API.endpoints.settings, signal ? { signal } : {});
  },

  update(body: UpdateSettingsRequest): Promise<UserSettings> {
    return api.patch<UserSettings>(API.endpoints.settings, body);
  },
};
